<template>
    <button class="toggle">
        <router-link :to="{ name: 'Action', params: { id: $route.params.cause_id  }}" class="toggle__label" :class="{ active: kind === 'action'}">
            {{ $t('action') }}
        </router-link>
        <router-link :to="{ name: 'Prayer', params: { id: $route.params.cause_id  }}" class="toggle__label" :class="{ active: kind === 'prayer' }">
            {{ $t('prayer') }}
        </router-link>
    </button>
</template>

<script>
  export default {
    name: 'Toggle',

    props: {
      kind: String
    },
  }
</script>
